<template>
  <div class="page-body">
    <PageTitle title="Offline Tank Report" path="frontdash" />

    <div class="container-fluid">
      <div class="row">
        <div class="col-lg-12">
          <div class="card">
            <div class="card-body badge-spacing">

              <div class="table-responsive custom-scrollbar">
                <button
                  class="btn btn-primary mb-3 me-2"
                  v-show="isOnline"
                  @click="syncData"
                >
                  Sync Data
                </button>
<button @click="exportTankData">Export Tank Data</button>
                <button
                  class="btn btn-danger mb-3"
                  v-show="isOnline"
                  @click="initExport"
                >
                  Show Other Options
                </button>

                <table class="table display datatable">
                  <thead>
                    <tr>
                      <th>Sr.No</th>
                      <th>Survey Date</th>
                      <th>Owner Name</th>
                      <th>Ward</th>
                      <th>Property No</th>
                      <th>Mobile</th>
                      <th>Address</th>
                      <th>Latitude</th>
                      <th>Longitude</th>
                      <th>Toilet Count</th>
                      <th>Tank Capacity</th>
                      <th>Soak Pit</th>
                      <th>Construction Year</th>
                      <th>Image</th>
                      <th class="hide">ID</th>
                    </tr>
                  </thead>

                  <tbody>
                    <tr v-for="(item, index) in tankReports" :key="item.id">
                      <td>{{ index + 1 }}</td>
                      <td>{{ item.iddate }}</td>
                      <td>{{ item.name }}</td>
                      <td>{{ item.ward }}</td>
                      <td>{{ item.property }}</td>
                      <td>{{ item.phone }}</td>
                      <td>{{ item.address }}</td>
                      <td>{{ item.tank_location_lat }}</td>
                      <td>{{ item.tank_location_lng }}</td>
                      <td>{{ item.toilet_count }}</td>
                      <td>{{ item.tank_capacity }}</td>
                      <td>{{ item.soak_pit_connected }}</td>
                      <td>{{ item.construction_year }}</td>
                      <td>
                        <span v-if="item.tank_image">📷</span>
                      </td>
                      <td class="hide">{{ item.id }}</td>
                    </tr>
                  </tbody>
                </table>

                <span class="text-danger">{{ error }}</span>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
th {
  text-transform: capitalize;
}
.table th,
.table td {
  padding: 0.4em !important;
}
.hide {
  display: none;
}
.dt-button {
  background: darkgreen;
  color: white;
  padding: 2px 6px;
  border-radius: 5px;
  margin-left: 5px;
}
</style>

<script>
import PageTitle from "@/components/PageTitle.vue";
import axios from "axios";
import { getAlldVeng_Tank, deleteTankSurveyRecord } from "@/dexie";

export default {
  name: "OfflineTankReport",
  components: { PageTitle },

  data() {
    return {
      tankReports: [],
      datatable: null,
      isOnline: navigator.onLine,
      error: ""
    };
  },

  mounted() {
    this.getOfflineData();
    window.addEventListener("online", this.updateOnlineStatus);
    window.addEventListener("offline", this.updateOnlineStatus);
  },

  beforeUnmount() {
    window.removeEventListener("online", this.updateOnlineStatus);
    window.removeEventListener("offline", this.updateOnlineStatus);
  },

  methods: {
    updateOnlineStatus() {
      this.isOnline = navigator.onLine;
    },

    initExport() {
      if (this.datatable) return;
      this.datatable = $(".datatable").DataTable({
        paging: true,
        ordering: true,
        autoWidth: false,
        dom: "Bfrtip",
        buttons: ["excel", "csv", "print"]
      });
    },

    async getOfflineData() {
      const records = await getAlldVeng_Tank();
      const temp = [];

      for (let i = records.length - 1; i >= 0; i--) {
        temp.push(JSON.parse(records[i].data));
      }

      this.tankReports = temp;
    },
async exportTankData() {
  try {
    const records = await getAlldVeng_Tank();

    const safeRecords = records.map(r => ({
      id: r.id,
      data: r.data,
      hasImage: !!r.blob, // avoid breaking export
      blob: r.blob || null
    }));

    const blob = new Blob([JSON.stringify(safeRecords)], {
      type: "application/json"
    });

    const url = URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.href = url;
    a.download = `tank-backup-${Date.now()}.json`;
    a.click();

    URL.revokeObjectURL(url);

    console.log("Export success:", safeRecords.length);
  } catch (err) {
    console.error("Export failed:", err);
  }
},
    async syncData() {
      $(".loader-wrapper").show();

      try {
        const records = await getAlldVeng_Tank();

        for (let i = 0; i < records.length; i++) {
            const r = records[i];

               if (!r.blob || !(r.blob instanceof Blob)) {
                console.warn("Skipping invalid image record:", r.id);
                continue;
              }
              
          const formData = new FormData();
          formData.append("image", records[i].blob, "tank_photo.png");
          formData.append("ques", records[i].data);
          formData.append("syncid", records[i].id);
          try {
                  const res = await axios.post("syncTankSurvey", formData);
        
                  if (res.data.status === 1) {
                    await deleteTankSurveyRecord(res.data.syncid);
                  }else if (res.data.status === 2) {
                    // await deleteTankSurveyRecord(res.data.syncid);
                  }
          } catch (apiErr) {
                console.error("API failed for:", r.id, apiErr);
                // continue loop instead of breaking everything
              }
        }

        await this.getOfflineData();
      } catch (err) {
        this.error = JSON.stringify(err);
      }

      $(".loader-wrapper").hide();
    }
  }
};
</script>
